import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en-US/translation.json';
import frTranslation from './locales/fr-FR/translation.json';

export interface ISupportedLang {
	enName: string,
	frName: string,
	code: string
}

export class SupportedLangs {
	static en: ISupportedLang = {
		enName: 'English',
		frName: 'Anglais',
		code: 'en'
	};
	static fr: ISupportedLang = {
		enName: 'French',
		frName: 'Français',
		code: 'fr'
	};
}

export const supportedLangsList: ISupportedLang[] = [
	SupportedLangs.en,
	SupportedLangs.fr
];

const resources = {
	en: {
		translation: enTranslation,
	},
	fr: {
		translation: frTranslation,
	},
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: SupportedLangs.en.code,
		debug: process.env.NODE_ENV === 'development',
		supportedLngs: [SupportedLangs.en.code, SupportedLangs.fr.code],
		nonExplicitSupportedLngs: true,
		interpolation: {
			escapeValue: false,
		},
		react: {
			useSuspense: false,
		},
	});

export default i18n;
